import { Button, Divider, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";

import '../css/BookingCalendar.css';
import { addDays, cmpDay, datesBetween, datesCount, endOfMonth, fmtKey, getHourArray, getInclusiveHoursDiff, HOURS, isSelectedDateIsPast, parseDateOnly, toHour, } from "../../../constants/DateUtils";
import { TimePanel } from "./TimePanel";
import { DatePanel } from "./DatePanel";
import { BACKEND_BASE_URL, BillStatus, BookingTimeRangeType, isEmpty, printDebugLog, StayType, SUCCESS, TEST_BACKEND_BASE_URL } from "../../../constants/Constants";
import axios from "axios";
import { CHECK_IN_TIME, CHECK_OUT_TIME } from "../../../constants/pojoservice";

const BookingCalendar = ({
    authUser,
    activeShopHash,
    bookingCount,
    readOnlyPast = true,
    disabledDate,
    previousDateBooking = [],
    setSnpLoader,
    roomId,
    setSnpComponent,
    clearSnpComponent,
    setBillingData,
    clearAllDetails,
    paymentInitiated,
    nextCateogory, billInformation, fetchBooking
}) => {

    useEffect(() => {
        printDebugLog("BookingCalendar default", roomId);
    }, [roomId])

    const [previousTimeBooking, setPreviousTimeBooking] = useState(new Map());

    const [checkInDate, setCheckInDate] = useState(null);
    const [checkOutDate, setCheckOutDate] = useState(null);
    const [checkInTime, setCheckInTime] = useState("");
    const [checkOutTime, setCheckOutTime] = useState("");
    const [timePanelDate, setTimePanelDate] = useState(null);
    const [timePanel, setTimePanel] = useState(false);

    useEffect(() => {
        printDebugLog("BookingCalendar timePanelDate", timePanelDate);
    }, [timePanelDate])

    useEffect(() => {
        printDebugLog("BookingCalendar previousTimeBooking", previousTimeBooking);
    }, [previousTimeBooking])

    useEffect(() => {
        printDebugLog("BookingCalendar timePanel", timePanel);
    }, [timePanel])

    // date with time range (par)
    const [currentDateSlot, setCurrentDateSlot] = useState(new Map());

    //list of time in integer
    const [currentTimeSlot, setCurrentTimeSlot] = useState([]);
    const [currentBookingIsDay, setCurrentBookingDay] = useState(false); //false means hourly

    const [checkInOutFocus, setCheckInOutFocus] = useState(CHECK_IN_TIME);


    const [viewDate, setViewDate] = useState(new Date());


    useEffect(() => {
        printDebugLog("BookingCalendar billInformation", billInformation);
        if (!isEmpty(billInformation?.checkInDate)) {
            setCheckInDate(parseDateOnly(billInformation?.checkInDate) || null);
        }
        if (!isEmpty(billInformation?.checkOutDate)) {
            setCheckOutDate(parseDateOnly(billInformation?.checkOutDate) || null);
        }

        if (!isEmpty(billInformation?.startTime)) {
            setCheckInTime(billInformation?.startTime);
        }

        if (!isEmpty(billInformation?.endTime)) {
            setCheckOutTime(billInformation?.endTime);
            const parseCheckInDate = parseDateOnly(billInformation?.checkInDate);
            const parseCheckOutDate = parseDateOnly(billInformation?.checkOutDate);
            const dateArr = datesBetween(parseCheckInDate, parseCheckOutDate);
            setCurrentDateSlot(prev => {
                const newMap = new Map(prev);
                for (let i = 0; i < dateArr.length; i++) {
                    const d = dateArr[i];
                    const dateStr = fmtKey(d);
                    if (billInformation?.checkInTime === "00:00:00" && billInformation?.checkOutTime === "23:00:00") {
                        newMap.set(dateStr, BookingTimeRangeType.FULL);
                    } else if (billInformation?.checkInTime === "00:00:00" && billInformation?.checkOutTime !== "23:00:00") {
                        newMap.set(dateStr, i === dateArr.length - 1 ? BookingTimeRangeType.PARTIAL : BookingTimeRangeType.FULL);
                    } else if (billInformation?.checkInTime !== "00:00:00" && billInformation?.checkOutTime === "23:00:00") {
                        newMap.set(dateStr, i === 0 ? BookingTimeRangeType.PARTIAL : BookingTimeRangeType.FULL);
                    } else {
                        newMap.set(dateStr, i === 0 ? BookingTimeRangeType.PARTIAL : i === dateArr.length - 1 ? BookingTimeRangeType.PARTIAL : BookingTimeRangeType.FULL);
                    }
                }

                return newMap;
            });
        }

        if (billInformation?.stayType === StayType.DAILY) {
            setCurrentBookingDay(true)
        } else if (billInformation?.stayType === StayType.HOURLY) {
            setCurrentBookingDay(false);
            const date = parseDateOnly(billInformation?.checkInDate);
            setTimePanelDate(date);
            setTimePanel(true);
            dateAddOperation(date, BookingTimeRangeType.PARTIAL);
            setCurrentTimeSlot(getHourArray(billInformation?.startTime, billInformation?.endTime))
        }
    }, [billInformation]);


    function getCheckInInfo(withPrefix = true) {
        const parseCheckInDate = checkInDate ? fmtKey(checkInDate) : "";
        const parseCheckTime = checkInTime || "";
        return `${withPrefix ? "Selected Check In : " : ""}${parseCheckInDate} ${parseCheckTime}`;
    }

    function getCheckOutInfo(withPrefix = true) {
        const parseCheckDate = checkOutDate ? fmtKey(checkOutDate) : "";
        const parseCheckTime = checkOutTime || "";
        return `${withPrefix ? "Selected Check Out : " : ""}${parseCheckDate} ${parseCheckTime}`;
    }


    function dateAddOperation(date, timeRange) {
        const dateStr = fmtKey(date);
        setCurrentDateSlot(prev => {
            const newMap = new Map(prev);
            newMap.set(dateStr, timeRange);
            return newMap;
        });
    }

    // function dateDeleteOperation(date) {
    //     const dateStr = fmtKey(date);
    //     setCurrentDateSlot(prev => {
    //         const newMap = new Map(prev);
    //         newMap.delete(dateStr);
    //         return newMap;
    //     });
    // };

    const deepConvertObjToMap = (obj) => {
        const map = new Map();
        for (const [key, value] of Object.entries(obj)) {
            map.set(Number(key), value);
        }
        return map;
    };
    const fetchTimeByDate = async (focus, selectedDate) => {
        printDebugLog("fetchTimeByDate", timePanel, timePanelDate);
        if (!authUser) {
            return;
        }
        setSnpLoader(true);
        try {
            const catgUrl = `${BACKEND_BASE_URL}fetch-calendar-time-view-by-room`;
            const mData = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    roomId: roomId,
                    selectedDate: fmtKey(selectedDate),
                },
            };
            const response = await axios.post(catgUrl, mData);
            printDebugLog("fetchTimeByDate", response.data);
            if (response.data.status === SUCCESS) {
                const details = response.data.payLoad.details || []
                if (details.length !== 0) {
                    const myMap = deepConvertObjToMap(details);
                    setPreviousTimeBooking(myMap);

                }
            }
            handleViewTimeForDate(focus, selectedDate, -1);
            setCurrentBookingDay(false);
            setSnpLoader(false);
            setViewDate(selectedDate)
        } catch (error) {
            console.error("fetchTimeByDate Error : ", error);
            setSnpLoader(false);
        }
    }

    const handleViewTimeForDate = (focus, selectedDate, timeRange = -1) => {
        printDebugLog("handleViewTimeForDate", focus, selectedDate);
        setTimePanelDate(selectedDate);
        if (!timePanel) {
            setTimePanel(true);
        }
        if (focus === CHECK_IN_TIME) {
            setCheckInDate(selectedDate);
            dateAddOperation(selectedDate, timeRange);
        } else if (focus === CHECK_OUT_TIME) {
            handleCheckOutDateAdd(selectedDate, BookingTimeRangeType.PARTIAL)
        }
    }

    const handleCheckinOnDateAddFull = (date) => {
        printDebugLog("handleCheckinOnDateAddFull", date);
        if (checkInDate === null) {
            dateAddOperation(date, BookingTimeRangeType.FULL);
        } else if (checkInDate !== null && checkOutDate === null) {
            const dateStr = fmtKey(date);
            const delDateStr = fmtKey(checkInDate);
            setCurrentDateSlot(prev => {
                const newMap = new Map(prev);
                newMap.delete(delDateStr);
                newMap.set(dateStr, BookingTimeRangeType.FULL);
                return newMap;
            });
        } else if (checkInDate !== null && checkOutDate !== null) {
            const dateStr = fmtKey(date);
            setCurrentDateSlot(() => {
                const newMap = new Map();
                newMap.set(dateStr, BookingTimeRangeType.FULL);
                return newMap;
            });
            setCheckOutTime("");
        }
        setCheckInDate(date);
        setTimePanelDate(date);
        !timePanel && setTimePanel(true);
        setCurrentTimeSlot(HOURS);
        setCheckInTime("00:00:00");
        setCheckInOutFocus(CHECK_OUT_TIME);
        setCurrentBookingDay(true);
    };

    const handleCheckOutDateAdd = (date, timeRange) => {
        printDebugLog("handleCheckOutDateAdd", date, timeRange);
        if (isSelectedDateIsPast(date, checkInDate)) {
            setSnpComponent(prev => ({
                ...prev,
                negativeReq: true,
                negativeAction: "Ok!",
                positiveAction: "Create Room",
                positiveReq: false,
                showDialog: true,
                outSideClickDismiss: true,
                cancelExtra: true,
                subTitle: `Checkout date (${fmtKey(date)}) cannot be selected as it’s before CheckIn date ${fmtKey(checkInDate)}.`,
                handleSnpCancel: () => clearSnpComponent(),
            }));
            return;
        }
        let breakInit = false;
        const dateArr = datesBetween(checkInDate, date);
        setCurrentDateSlot(prev => {
            const newMap = new Map(prev);
            for (let i = 1; i < dateArr.length; i++) {
                //In between only checking & add
                const d = dateArr[i];
                const dateStr = fmtKey(d);
                const bookingDetails = previousDateBooking?.[dateStr] || null;
                if (bookingDetails) {
                    breakInit = true;
                    setSnpComponent(prev => ({
                        ...prev,
                        negativeReq: true,
                        negativeAction: "Ok!",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `Checkout date (${fmtKey(date)}) cannot be selected as a booking exists on ${dateStr}.`,
                        handleSnpCancel: () => clearSnpComponent(),
                    }))
                    break;
                } else {
                    newMap.set(dateStr, i === dateArr.length - 1 ? timeRange : BookingTimeRangeType.FULL);
                }
            }
            return newMap;
        });

        if (breakInit) {
            setCheckOutDate(null);
            setCheckOutTime("");
            setTimePanelDate(null);
            setTimePanel(false);
            setCurrentDateSlot(() => {
                const newMap = new Map();
                newMap.set(fmtKey(checkInDate), BookingTimeRangeType.FULL);
                return newMap;
            });
        } else {
            setCheckOutDate(date);
            !timePanel && setTimePanel(true);
            setTimePanelDate(date);
            setCurrentBookingDay(!isClickedSameDate(date));
            if (timeRange === BookingTimeRangeType.FULL) {
                setCurrentTimeSlot(HOURS);
                setCheckOutTime("23:00:00");
                setCheckInOutFocus(CHECK_IN_TIME);
            } else {
                setCurrentTimeSlot([]);
            }
        }
    };

    const handleCheckOutDate = (date, timeRange) => {
        if (checkOutDate !== null) {
            setCurrentDateSlot(() => {
                const newMap = new Map();
                newMap.set(fmtKey(checkInDate), BookingTimeRangeType.FULL);
                return newMap;
            });
        }
        handleCheckOutDateAdd(date, timeRange);
    }

    const validateOnAddFull = (date) => {
        printDebugLog("handleOnDateAddFull", checkInOutFocus, date);
        if (checkInOutFocus === CHECK_IN_TIME) {
            handleCheckinOnDateAddFull(date);
        } else if (checkInOutFocus === CHECK_OUT_TIME) {
            handleCheckOutDate(date, BookingTimeRangeType.FULL)
        }
    }

    const handleOnDateAddPartial = (date, alreadyBookingAvailable) => {
        printDebugLog("handleOnDateAddPartial", checkInOutFocus, date, alreadyBookingAvailable);
        if (alreadyBookingAvailable) {
            fetchTimeByDate(checkInOutFocus, date);
        } else {
            handleViewTimeForDate(checkInOutFocus, date, BookingTimeRangeType.PARTIAL);
        }
    }

    const handleCheckInTimeAddPartial = (timeInteger) => {
        printDebugLog("handleCheckInTimeAddPartial", timeInteger);
        setCheckInTime(toHour(timeInteger));
        setCurrentTimeSlot(prev => {
            const newArr = [...prev];
            newArr.push(timeInteger);
            return newArr;
        });
        setCheckInOutFocus(CHECK_OUT_TIME);
    }

    const handleCheckBooking = (focus, selectedDate, alreadyBookingAvailable) => {
        printDebugLog("handleCheckBooking", focus, selectedDate, alreadyBookingAvailable);
        if (alreadyBookingAvailable) {
            fetchTimeByDate(focus, selectedDate);
        } else {
            const timeRange = currentDateSlot.get(fmtKey(selectedDate));
            !timePanel && setTimePanel(true);
            setTimePanelDate(selectedDate);
            if (timeRange === BookingTimeRangeType.FULL) {
                setCurrentTimeSlot(HOURS);
            } else if (timeRange === BookingTimeRangeType.PARTIAL) {
                if (cmpDay(checkInDate, checkOutDate) === 0) {
                    setCurrentTimeSlot(getHourArray(checkInTime, checkOutTime));
                } else if (cmpDay(checkInDate, selectedDate) === 0) {
                    setCurrentTimeSlot(getHourArray(checkInTime, "23:00:00"));
                } else if (cmpDay(checkOutDate, selectedDate) === 0) {
                    setCurrentTimeSlot(getHourArray("00:00:00", checkOutTime));
                }
            }
        }
    }

    function handleCheckOutTimeAddPartial(timeInteger) {
        printDebugLog("handleCheckOutTimeAddPartial", timeInteger);
        const timeKey = toHour(timeInteger);

        if (!currentBookingIsDay && timeInteger <= currentTimeSlot[0]) {
            setSnpComponent(prev => ({
                ...prev,
                negativeReq: true,
                negativeAction: "Ok!",
                positiveReq: false,
                showDialog: true,
                outSideClickDismiss: true,
                cancelExtra: true,
                subTitle: `Checkout time (${timeKey}) cannot be selected as it’s before ${checkInTime}.`,
                handleSnpCancel: () => clearSnpComponent(),
            }))
        } else {
            setCheckOutTime(timeKey);
            if (checkOutDate == null) {
                setCheckOutDate(checkInDate);
                setCurrentBookingDay(false);
                let timeAvailable = -1;
                if (previousTimeBooking.length > 0) {

                    for (let i = currentTimeSlot[0] + 1; i <= timeInteger; i++) {
                        if (previousTimeBooking.has(i)) {
                            timeAvailable = i;
                            break;
                        }
                    }
                }
                if (timeAvailable > -1) {
                    setSnpComponent(prev => ({
                        ...prev,
                        negativeReq: true,
                        negativeAction: "Ok!",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `Cannot select the checkout time (${timeKey}) because there is an existing booking during this period, i.e., ${toHour(timeAvailable)}.`,
                        handleSnpCancel: () => clearSnpComponent(),
                    }))
                } else {
                    setCurrentTimeSlot(prev => {
                        const newArr = [...prev];
                        const start = newArr[0] + 1;
                        for (let i = start; i <= timeInteger; i++) {
                            newArr.push(i);
                        }
                        return newArr;
                    });
                }
            } else {
                let timeAvailable = -1;
                if (previousTimeBooking.length > 0) {
                    for (let i = 0; i <= timeInteger; i++) {
                        if (previousTimeBooking.has(i)) {
                            timeAvailable = i;
                            break;
                        }
                    }
                }
                if (timeAvailable > -1) {
                    setSnpComponent(prev => ({
                        ...prev,
                        negativeReq: true,
                        negativeAction: "Ok!",
                        positiveReq: false,
                        showDialog: true,
                        outSideClickDismiss: true,
                        cancelExtra: true,
                        subTitle: `Cannot select the checkout time (${timeKey}) because there is an existing booking during this period, i.e., ${toHour(timeAvailable)}.`,
                        handleSnpCancel: () => clearSnpComponent(),
                    }))
                } else {
                    setCurrentTimeSlot(prev => {
                        const newArr = [...prev];
                        newArr.push(timeInteger);
                        newArr.sort((a, b) => a - b);
                        return newArr;
                    });
                }

            }
        }
    }

    const isClickedSameDate = (d) => {
        if (checkInOutFocus === CHECK_IN_TIME) {
            return false;
        }
        return cmpDay(checkInDate, d) === 0;
    }

    const onClickSameDate = (date) => {
        setCheckOutDate(date);
        !timePanel && setTimePanel(true);
        setTimePanelDate(date);
        setCurrentBookingDay(true);
        setCheckInOutFocus(CHECK_IN_TIME);
        setCheckOutTime("23:00:00");
    }

    const getDuration = (defVal = 0) => {
        if (currentBookingIsDay) {
            if (checkInDate !== null && checkOutTime !== null) {
                return datesCount(checkInDate, checkOutDate);
            }
            return defVal;
        }
        if (!isEmpty(checkInTime) && !isEmpty(checkOutTime)) {
            return getInclusiveHoursDiff(checkInTime, checkOutTime);
        }
        return defVal;
    }

    function handleFullClear() {
        printDebugLog("handleFullClear");
        setCurrentDateSlot(new Map());
        setCheckInDate(null);
        setCheckInTime("");
        setCheckOutDate(null);
        setCheckOutTime("");
        setTimePanel(false);
        setTimePanelDate(null);
        setCurrentTimeSlot([]);
        setCurrentBookingDay(false);
        setCheckInOutFocus(CHECK_IN_TIME);

        setBillingData(prev => ({
            ...prev,
            stayType: -1,
            startTime: "",
            endTime: "",
            checkInDate: "",
            checkOutDate: "",
            totalDaysStay: "",
        }));
    }



    const renderTimePanel = () => {
        //console.log("Rendering TimePanel →", timePanelDate); // ✅ log when rendered

        if (!timePanel) return null;

        return (
            <TimePanel
                selectedDate={timePanelDate}
                previousTimeBooking={previousTimeBooking}
                currentTimeSlot={currentTimeSlot}
                readOnlyPast={readOnlyPast}
                checkInOutFocus={checkInOutFocus}
                checkInDateStr={getCheckInInfo(false)}
                checkOutDateStr={getCheckOutInfo(false)}
                currentBookingIsDay={currentBookingIsDay}
                handleCheckInTimeAddPartial={handleCheckInTimeAddPartial}
                handleCheckOutTimeAddPartial={handleCheckOutTimeAddPartial}
                fetchBooking={fetchBooking}
            />
        );
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#fffadf",
                    }}>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <p style={{
                                fontWeight: "bold",
                                whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                fontSize: '14px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                padding: '2px'
                            }}>{getCheckInInfo()}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p style={{
                                fontWeight: "bold",
                                whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                fontSize: '14px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                padding: '2px'
                            }}>{getCheckOutInfo()}</p>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <DatePanel
                viewDate={viewDate}
                bookingCount={bookingCount}
                readOnlyPast={readOnlyPast}
                disabledDate={disabledDate}
                previousDateBooking={previousDateBooking}
                currentDateSlot={currentDateSlot}
                isDay={currentBookingIsDay}
                isClickedSameDate={isClickedSameDate}
                onClickSameDate={onClickSameDate}
                onClickFull={validateOnAddFull}
                onClickPartial={handleOnDateAddPartial}
                onClickCheckBooking={handleCheckBooking}
                goNext={() => setViewDate((d) => addDays(endOfMonth(d), 1))}
                goPrev={() => setViewDate((d) => addDays(new Date(d.setDate(1)), -1))}
            />
            {
                renderTimePanel()
            }
            {
                !paymentInitiated &&
                <Grid item xs={12}>
                    <Divider sx={{ borderBottom: '1px solid black' }} />
                </Grid>
            }
            {
                !paymentInitiated && <Grid item xs={12} md={6} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Button
                        size="small"
                        variant="outlined"
                        onPointerDown={() => handleFullClear()}
                    >
                        Clear
                    </Button>
                    {
                        (checkInDate !== null && checkOutDate !== null && !isEmpty(checkInTime) && !isEmpty(checkOutTime)) &&
                        <Button
                            size="small"
                            variant="contained"
                            disabled={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                            onPointerDown={() => {
                                setBillingData(prev => ({
                                    ...prev,
                                    stayType: currentBookingIsDay ? StayType.DAILY : StayType.HOURLY,
                                    startTime: checkInTime,
                                    endTime: checkOutTime,
                                    billStatus: BillStatus.MODE_ESTIMATION,
                                    checkInDate: `${fmtKey(checkInDate)} ${checkInTime}`,
                                    checkOutDate: `${fmtKey(checkOutDate)} ${checkOutTime}`,
                                    totalDaysStay: getDuration(0),
                                }));
                                clearAllDetails();
                                nextCateogory();
                                setSnpComponent(prev => ({
                                    ...prev,
                                    snackBarOpen: true,
                                    snackBarMsg: "Updated Successfully",
                                }))
                            }}
                        >
                            Save
                        </Button>
                    }

                </Grid>
            }
            {
                !paymentInitiated &&
                <Grid item xs={12}>
                    <Divider sx={{ borderBottom: '1px solid black' }} />
                </Grid>
            }
        </Grid>
    )
};

export { BookingCalendar };